'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _navigationActions = require('../../reducers/navigationActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


var ROOT_PATHNAME = '/';
var isRoot = function isRoot(pathname) {
    return pathname === ROOT_PATHNAME;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        redirectToLogin: function redirectToLogin(_ref) {
            var from = _ref.from;
            return dispatch((0, _navigationActions.navigateToLogin)({ from: from }));
        },
        redirectToBoard: function redirectToBoard(_ref2) {
            var boardId = _ref2.boardId;
            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId }));
        }
    };
};

/**
 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
 * this version of React Router when the current route matches exactly ('/').
 */

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var WorkspaceRootRedirection = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
        _inherits(WorkspaceRootRedirection, _React$Component);

        function WorkspaceRootRedirection() {
            var _ref3;

            var _temp, _this, _ret;

            _classCallCheck(this, WorkspaceRootRedirection);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = WorkspaceRootRedirection.__proto__ || Object.getPrototypeOf(WorkspaceRootRedirection)).call.apply(_ref3, [this].concat(args))), _this), _this.redirectIfRoot = function (props) {
                var isGuest = props.isGuest,
                    isUserAvailable = props.isUserAvailable,
                    pathname = props.location.pathname,
                    redirectToLogin = props.redirectToLogin,
                    redirectToBoard = props.redirectToBoard,
                    currentBoardId = props.currentBoardId;


                if (!isRoot(pathname)) return;

                if (isGuest) return redirectToLogin({ redirect: pathname });
                if (isUserAvailable) return redirectToBoard({ boardId: currentBoardId });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(WorkspaceRootRedirection, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.redirectIfRoot(this.props);
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var pathname = nextProps.location.pathname,
                    isUserAvailable = nextProps.isUserAvailable;


                if (this.props.location.pathname === pathname && this.props.isUserAvailable === isUserAvailable) return;

                this.redirectIfRoot(nextProps);
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, this.props);
            }
        }]);

        return WorkspaceRootRedirection;
    }(_react2.default.Component)) || _class);


    WorkspaceRootRedirection.propTypes = {
        isGuest: _propTypes2.default.bool,
        isUserAvailable: _propTypes2.default.bool,
        redirectToLogin: _propTypes2.default.func,
        redirectToBoard: _propTypes2.default.func,
        currentBoardId: _propTypes2.default.string,
        location: _propTypes2.default.object.isRequired
    };

    return WorkspaceRootRedirection;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/decorators/workspaceRootRedirectionDecorator.js
// module id = 2157
// module chunks = 0